<template>
    <div class="w-10/12 md:w-2/5 bg-white rounded shadow-2xl">
        <div class="relative bg-gray-200 rounded-t py-4 px-4 xl:px-8">
            <svg
                class="hidden md:block absolute -ml-5 -mb-10 left-0 bottom-0"
                width="30px"
                height="30px"
                viewBox="0 0 9 16"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                >
                    <g
                        id="Tooltips-"
                        transform="translate(-874.000000, -1029.000000)"
                        fill="#FFFFFF"
                    >
                        <g
                            id="Group-3-Copy-16"
                            transform="translate(850.000000, 975.000000)"
                        >
                            <g
                                id="Group-2"
                                transform="translate(24.000000, 0.000000)"
                            >
                                <polygon
                                    id="Triangle"
                                    transform="translate(4.500000, 62.000000) rotate(-90.000000) translate(-4.500000, -62.000000) "
                                    points="4.5 57.5 12.5 66.5 -3.5 66.5"
                                ></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <svg
                class="absolute top-0 -mt-5 block md:hidden"
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="23"
                viewBox="0 0 26 23"
                fill="none"
            >
                <path
                    id="Polygon 2"
                    d="M13 0L25.9904 22.5H0.00961876L13 0Z"
                    fill="#e5e7eb"
                />
            </svg>
            <p
                class="text-base text-gray-800 font-normal leading-normal tracking-normal"
            >
                {{ filter.name }}
            </p>
        </div>
        <Listbox as="div" v-model="selected">
            <div class="mt-1 relative p-[20px]">
                <ListboxButton
                    class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                    <span class="flex items-center">
                        <img
                            :src="selected.avatar"
                            alt=""
                            class="flex-shrink-0 h-6 w-6 rounded-full"
                        />
                        <span class="ml-3 block truncate">{{
                            selected.name
                        }}</span>
                    </span>
                    <span
                        class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                    >
                        <SelectorIcon
                            class="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                        />
                    </span>
                </ListboxButton>

                <transition
                    leave-active-class="transition ease-in duration-100"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <ListboxOptions
                        class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                    >
                        <ListboxOption
                            as="template"
                            v-for="person in people"
                            :key="person.id"
                            :value="person"
                            v-slot="{ active, selected }"
                        >
                            <li
                                @click.prevent="handleSelect(person)"
                                :class="[
                                    active
                                        ? 'text-white bg-indigo-600'
                                        : 'text-gray-900',
                                    'cursor-default select-none relative py-2 pl-3 pr-9',
                                ]"
                            >
                                <div class="flex items-center">
                                    <img
                                        :src="person.avatar"
                                        alt=""
                                        class="flex-shrink-0 h-6 w-6 rounded-full"
                                    />
                                    <span
                                        :class="[
                                            selected
                                                ? 'font-semibold'
                                                : 'font-normal',
                                            'ml-3 block truncate',
                                        ]"
                                    >
                                        {{ person.name }}
                                    </span>
                                </div>

                                <span
                                    v-if="selected"
                                    :class="[
                                        active
                                            ? 'text-white'
                                            : 'text-indigo-600',
                                        'absolute inset-y-0 right-0 flex items-center pr-4',
                                    ]"
                                >
                                    <CheckIcon
                                        class="h-5 w-5"
                                        aria-hidden="true"
                                    />
                                </span>
                            </li>
                        </ListboxOption>
                    </ListboxOptions>
                </transition>
            </div>
        </Listbox>
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
} from "@headlessui/vue";
import { CheckIcon, SelectorIcon } from "@heroicons/vue/solid";

export default {
    components: {
        Listbox: Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CheckIcon,
        SelectorIcon,
    },
    props: {
        filter: {
            type: Object,
            default: () => {},
        },
    },
    setup(props, { emit }) {
        const people = ref([]);
        const selected = ref({});
        onMounted(async () => {
            const { data } = await axios.get("/elos");
            people.value = data.data.map((person) => ({
                ...person,
                selected: false,
            }));
            selected.value = people.value[0];
        });

        const handleSelect = (selection) => {
            console.log(selection);
            emit(
                "apply",
                Object.assign(props.filter, { value: selection.name })
            );
        };

        return {
            people,
            handleSelect,
            selected,
        };
    },
};
</script>
